export const ASSOCIATIONS_PAGE = {
  title: "Les associations de la commune",
  eyebrow: "Vie associative",
  description:
    "Retrouvez les associations locales, leurs contacts, leurs activités et leur localisation lorsque l’adresse est renseignée.",
  heroImageUrl:
    "https://api.eynesse33.fr/uploads/photos/2026/03/photo_1772829825215_wkg4xr.webp",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Ville" },
    { label: "Associations" },
  ],
};

export const ASSOCIATIONS_FILTER_LABELS = {
  searchPlaceholder: "Exemple : judo, musique, solidarité, sport…",
};